import React from "react";
import WorkTabContent from "../components/WorkTabContent/WorkTabContent";
import moment from "moment";

const AboutContainer = () => {
  return (
    <>
      <div className="spacer" data-height="100"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-2">
            <span className="tags top-tags">
              {"<html>"}
              <br></br>
            </span>
          </div>
        </div>
      </div>
      <div className="spacer" data-height="100"></div>
      <section id="about">
        <div className="container">
          {/*Intro*/}
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-11 aboutme">
              <h1 className="animate__animated animate__fadeInDown">
                .about()
              </h1>
              <div className="spacer" data-height="10"></div>
              <div className="spacer" data-height="60"></div>
              <div className="para animate__animated animate__fadeIn animate__delay-1s">
                <div className="col-md-11 info">
                  <p>
                    Hello! My name is Quan Le - a Front-End developer currently
                    living in 🇰🇷 Seoul, South Korea. I have passionated about{" "}
                    <span>3D world</span>, <span>Web Design</span> and animating
                    things.
                    <br></br>
                    <br></br>
                    My main focus these days is building a 3D experience on the
                    web with <span>WebGL</span>, <span>GLSL</span> and animation
                    stuffs.
                  </p>
                  <div className="aboutme-timeline">
                    <h6>TIMELINE</h6>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="537.58"
                      height="74"
                      viewBox="0 0 537.58 74"
                    >
                      <defs>
                        <clipPath id="clip-timeline">
                          <rect width="537.58" height="74" />
                        </clipPath>
                      </defs>
                      <g id="timeline" clipPath="url(#clip-timeline)">
                        <g
                          id="Group_2"
                          data-name="Group 2"
                          transform="translate(0 -76)"
                        >
                          <rect
                            id="Rectangle_1"
                            data-name="Rectangle 1"
                            width="251"
                            height="42"
                            transform="translate(261 92)"
                            fill="#8b88b1"
                            opacity="0.25"
                          />
                          <g
                            id="Group_1"
                            data-name="Group 1"
                            transform="translate(11)"
                          >
                            <path
                              id="Path_1"
                              data-name="Path 1"
                              d="M0,0H526.581"
                              transform="translate(0 133.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_2"
                              data-name="Line 2"
                              y2="8"
                              transform="translate(100.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_5"
                              data-name="Line 5"
                              y2="8"
                              transform="translate(150.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_6"
                              data-name="Line 6"
                              y2="8"
                              transform="translate(200.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_7"
                              data-name="Line 7"
                              y2="8"
                              transform="translate(250.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_8"
                              data-name="Line 8"
                              y2="8"
                              transform="translate(300.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_9"
                              data-name="Line 9"
                              y2="8"
                              transform="translate(350.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_10"
                              data-name="Line 10"
                              y2="8"
                              transform="translate(400.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_11"
                              data-name="Line 11"
                              y2="8"
                              transform="translate(450.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_12"
                              data-name="Line 12"
                              y2="8"
                              transform="translate(500.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_4"
                              data-name="Line 4"
                              y2="8"
                              transform="translate(50.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                            <line
                              id="Line_3"
                              data-name="Line 3"
                              y2="8"
                              transform="translate(0.5 129.5)"
                              fill="none"
                              stroke="#8b88b1"
                              strokeWidth="1"
                            />
                          </g>
                          <text
                            id="_2007"
                            data-name="2007"
                            transform="translate(0 147)"
                            fill="#8b88b1"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              2007
                            </tspan>
                          </text>
                          <text
                            id="_2011"
                            data-name="2011"
                            transform="translate(53 147)"
                            fill="#8b88b1"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              2011
                            </tspan>
                          </text>
                          <text
                            id="_2014"
                            data-name="2014"
                            transform="translate(152 147)"
                            fill="#8b88b1"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              2014
                            </tspan>
                          </text>
                          <text
                            id="_2016"
                            data-name="2016"
                            transform="translate(253 147)"
                            fill="#8b88b1"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              2016
                            </tspan>
                          </text>
                          <text
                            id="_2017"
                            data-name="2017"
                            transform="translate(302 147)"
                            fill="#8b88b1"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              2017
                            </tspan>
                          </text>
                          <text
                            id="_2018"
                            data-name="2018"
                            transform="translate(352 147)"
                            fill="#8b88b1"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              2018
                            </tspan>
                          </text>
                          <text
                            id="_2019"
                            data-name="2019"
                            transform="translate(401 147)"
                            fill="#8b88b1"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              2019
                            </tspan>
                          </text>
                          <text
                            id="_2022"
                            data-name="2022"
                            transform="translate(501 147)"
                            fill="#8b88b1"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              2022
                            </tspan>
                          </text>
                          <line
                            id="Line_13"
                            data-name="Line 13"
                            x2="50.5"
                            transform="translate(11 124.5)"
                            fill="none"
                            stroke="#f24c64"
                            strokeWidth="3"
                          />
                          <line
                            id="Line_14"
                            data-name="Line 14"
                            x2="100"
                            transform="translate(61.5 124.5)"
                            fill="none"
                            stroke="#28abe3"
                            strokeWidth="3"
                          />
                          <line
                            id="Line_15"
                            data-name="Line 15"
                            x2="100"
                            transform="translate(161.5 124.5)"
                            fill="none"
                            stroke="#fcb13c"
                            strokeWidth="3"
                          />
                          <line
                            id="Line_18"
                            data-name="Line 18"
                            x2="251"
                            transform="translate(261 94)"
                            fill="none"
                            stroke="#64ffda"
                            strokeWidth="3"
                          />
                          <line
                            id="Line_16"
                            data-name="Line 16"
                            x2="82"
                            transform="translate(311.5 124.5)"
                            fill="none"
                            stroke="#010e52"
                            strokeWidth="3"
                          />
                          <line
                            id="Line_17"
                            data-name="Line 17"
                            x2="118"
                            transform="translate(393.5 124.5)"
                            fill="none"
                            stroke="#f24c64"
                            strokeWidth="3"
                          />
                          <text
                            id="Bachelor"
                            transform="translate(11 117)"
                            fill="#ccd6f6"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              Bachelor
                            </tspan>
                          </text>
                          <text
                            id="Master"
                            transform="translate(162 117)"
                            fill="#ccd6f6"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              Master
                            </tspan>
                          </text>
                          <text
                            id="Letsee_Inc."
                            data-name="Letsee, Inc."
                            transform="translate(393 117)"
                            fill="#ccd6f6"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              Letsee, Inc.
                            </tspan>
                          </text>
                          <text
                            id="Self-employed"
                            transform="translate(261 85)"
                            fill="#ccd6f6"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              Self-employed
                            </tspan>
                          </text>
                          <text
                            id="Researcher"
                            transform="translate(311 117)"
                            fill="#ccd6f6"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              Researcher
                            </tspan>
                          </text>
                          <text
                            id="Enclave_ODC_Co._Ltd"
                            data-name="Enclave ODC
  Co., Ltd"
                            transform="translate(62 106)"
                            fill="#ccd6f6"
                            fontSize="10"
                            fontFamily="ProximaNova-Regular, Proxima Nova"
                          >
                            <tspan x="0" y="0">
                              Enclave ODC
                            </tspan>
                            <tspan x="0" y="12">
                              Co., Ltd
                            </tspan>
                          </text>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="spacer" data-height="60"></div>
          {/*Experience*/}
          <div
            className="row animate__animated animate__fadeIn animate__delay-1s"
            style={{ minHeight: "400px" }}
          >
            <div className="col-md-1"></div>
            <div className="col-md-11">
              <h3 style={{ marginBottom: "20px" }}>Experience</h3>
              <WorkTabContent />
            </div>
          </div>
          <div className="spacer" data-height="20"></div>
          {/*Main Skills*/}
          <div className="row animate__animated animate__fadeIn animate__delay-1s">
            <div className="col-md-1"></div>
            <div className="col-md-11 tag-sec-start">
              <h3>Main Skills</h3>
            </div>
          </div>
          <div className="row animate__animated animate__fadeIn animate__delay-1s">
            <div className="col-md-1"></div>
            <div className="col-md-11 main-skills">
              <ul>
                <li>
                  Threejs, A-Frame, WebGL
                  <br></br>
                  8thwall, ARToolkit
                  <br></br>
                  JavaScript,
                  <br></br>
                  React.js, R3F
                </li>
                <li>
                  Unity3D,
                  <br></br>
                  Microsoft HoloLens, MRTK
                  <br></br>
                  Leap Motion Controller
                </li>
                <li>
                  HTML5, CSS3, GSAP,
                  <br></br>
                  AdobeXD, Zeplin,
                  <br></br>
                  UX/UI design
                </li>
              </ul>
            </div>
          </div>
          <div className="spacer" data-height="20"></div>
          {/*Tools*/}
          <div className="row animate__animated animate__fadeIn animate__delay-1s">
            <div className="col-md-1"></div>
            <div className="col-md-11">
              <h3>Tools/years</h3>
            </div>
          </div>
          <div className="row animate__animated animate__fadeIn animate__delay-1s">
            <div className="col-md-1"></div>
            <div className="col-md-11 main-tools">
              <ul>
                <li>Three.js/+{countYears(2019, 0)}</li>
                <li>A-Frame/+{countYears(2021, 0)}</li>
                <li>WebGL/+{countYears(2019, 0)}</li>
                <li>8thwall/+{countYears(2021, 0)}</li>
                <li>ARToolkit/+{countYears(2014, 2016)}</li>
                <li>JavaScript/+{countYears(2015, 0)}</li>
                <li>React.js/+{countYears(2021, 0)}</li>
                <li>R3F/+{countYears(2021, 0)}</li>
              </ul>
              <ul>
                <li>Unity3D/+{countYears(2016, 0)}</li>
                <li>Microsoft HoloLens, MRTK/+{countYears(2017, 2019)}</li>
                <li>Leap Motion Controller/+{countYears(2014, 2017)}</li>
                <li>Blender/+{countYears(2021, 0)}</li>
              </ul>
              <ul>
                <li>HTML5/+{countYears(2015, 0)}</li>
                <li>CSS3/+{countYears(2015, 0)}</li>
                <li>GSAP/+{countYears(2020, 0)}</li>
                <li>Node.js/+{countYears(2018, 0)}</li>
              </ul>
              <ul>
                <li>AdobeXD/+{countYears(2016, 0)}</li>
                <li>Zeplin/+{countYears(2020, 0)}</li>
                <li>Figma/+{countYears(2021, 0)}</li>
              </ul>
            </div>
          </div>
          <div className="spacer" data-height="20"></div>
          {/*Languages*/}
          <div className="row animate__animated animate__fadeIn animate__delay-1s">
            <div className="col-md-1"></div>
            <div className="col-md-11">
              <h3>Languages</h3>
            </div>
          </div>
          <div className="row animate__animated animate__fadeIn animate__delay-1s">
            <div className="col-md-1"></div>
            <div className="col-md-11 main-languages">
              <ul>
                <li>
                  {"// fluent "}
                  <br></br> <em>en-US</em> English
                </li>
                <li>
                  {"// intermediate"} <br></br> <em>kr-KR</em> Korean
                </li>
              </ul>
            </div>
          </div>
          <div className="spacer" data-height="20"></div>
          {/*Interest*/}
          <div className="row animate__animated animate__fadeIn animate__delay-1s">
            <div className="col-md-1"></div>
            <div className="col-md-11 tag-sec-stop">
              <h3>Also busy with</h3>
            </div>
          </div>
          <div className="row animate__animated animate__fadeIn animate__delay-1s">
            <div className="col-md-1"></div>
            <div className="col-md-11 main-languages">
              <ul>
                <li>📚 Reading</li>
                <li>👩‍🎨 Drawing & Coloring</li>
                <li>🎮 Video games</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
      </section>
      <div className="spacer" data-height="100"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-2">
            <span className="tags bottom-tags">
              <br></br>
              {"</html>"}
            </span>
          </div>
        </div>
      </div>
      <div className="spacer" data-height="100"></div>
    </>
  );
};

const countYears = (start, end) => {
  if (end === 0) {
    end = moment().year();
  }
  const a = moment([end, 0]);
  const b = moment([start, 0]);
  const diff = a.diff(b, "years");
  return Math.abs(diff);
};

export default AboutContainer;
